document.addEventListener('DOMContentLoaded', () => {
  const groups = document.querySelectorAll('.yn-mobile-shop__group');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  groups.forEach((group) => {
    const summary = group.querySelector(':scope > summary');
    if (!summary || reducedMotion) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (group.classList.contains('yn-mobile-shop__group--animating')) return;
      group.classList.add('yn-mobile-shop__group--animating');

      if (group.open) {
        summary.setAttribute('aria-expanded', 'false');
        group.classList.add('yn-mobile-shop__group--closing');
        window.setTimeout(() => {
          group.open = false;
          group.classList.remove('yn-mobile-shop__group--closing', 'yn-mobile-shop__group--animating');
        }, 300);
        return;
      }

      group.open = true;
      summary.setAttribute('aria-expanded', 'true');
      group.classList.add('yn-mobile-shop__group--opening');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          group.classList.remove('yn-mobile-shop__group--opening');
          window.setTimeout(() => {
            group.classList.remove('yn-mobile-shop__group--animating');
          }, 300);
        });
      });
    });
  });
});
